import { ReactComponent as InboxIcon } from "./assets/images/icons/inbox.svg";
import { ReactComponent as InventoryIcon } from "./assets/images/icons/inventory.svg";

const categories = [
  {
    id: 'Administracion',
    rol: ['admin'],
    url: '/admin/usuarios',
    raiz: '/admin',
    icon: InboxIcon
  },
  /*     {
        id: 'Configuracion',
        rol: 'admin',
        children: [
          { id: 'Tipos de Documentos', icon: <DescriptionIcon/>, url: '/admin/configuracion/tipo-documento', rol: 'admin' },
          { id: 'Aplicaciones Externas', icon: <ExitToAppIcon /> ,url: '/admin/configuracion/aplicaciones-externas', rol: 'admin'},
          { id: 'Número MTESS Patronal', icon: <DialpadIcon /> ,url: '/admin/configuracion/numero-patronal', rol: 'admin'},
        ],
      }, */
  {
    id: 'Notificacion',
    rol: ['admin'],
    url: '/notificacion/configuracion-correo',
    raiz: '/notificacion',
    icon: InventoryIcon
  },
/*   {
    id: 'Configuracion Sistema',
    rol: ['admin'],
    url: '/configuracion/app',
    raiz: '/configuracion',
    icon: 'configuracion'
  }, */
];
export default categories;